const enchants = {
  AUTHORITY_OF_AIR_ENCHANT: {
    id: 448833,
    name: 'Authority of Air',
    icon: 'ability_skyreach_four_wind',
  },
  AUTHORITY_OF_AIR_BUFF: {
    id: 448834,
    name: 'Authority of Air',
    icon: 'ability_skyreach_four_wind',
  },
  AUTHORITY_OF_FIERY_RESOLVE_ENCHANT: {
    id: 449210,
    name: 'Authority of Fiery Resolve',
    icon: 'spell_holy_healingaura',
  },
  AUTHORITY_OF_FIERY_RESOLVE_BUFF: {
    id: 449212,
    name: 'Authority of Fiery Resolve',
    icon: 'spell_holy_healingaura',
  },
  AUTHORITY_OF_RADIANT_POWER_ENCHANT: {
    id: 448623,
    name: 'Authority of Radiant Power',
    icon: 'inv_ability_holyfire_orb',
  },
  AUTHORITY_OF_RADIANT_POWER_BUFF: {
    id: 448730,
    name: 'Authority of Radiant Power',
    icon: 'inv_ability_holyfire_orb',
  },
  AUTHORITY_OF_RADIANT_POWER_DAMAGE: {
    id: 448744,
    name: 'Authority of Radiant Power',
    icon: 'inv_ability_holyfire_orb',
  },
  AUTHORITY_OF_STORMS_ENCHANT: {
    id: 449023,
    name: 'Authority of Storms',
    icon: 'spell_nature_unrelentingstorm',
  },
  AUTHORITY_OF_STORMS_DAMAGE: {
    id: 449024,
    name: 'Authority of Storms',
    icon: 'spell_nature_unrelentingstorm',
  },
  AUTHORITY_OF_THE_DEPTHS_ENCHANT: {
    id: 449218,
    name: 'Authority of the Depths',
    icon: 'spell_shadow_gathershadows',
  },
  AUTHORITY_OF_THE_DEPTHS_DAMAGE: {
    id: 449217,
    name: 'Authority of the Depths',
    icon: 'spell_shadow_gathershadows',
  },
  STORMRIDERS_FURY_ENCHANT: {
    id: 449099,
    name: "Stormrider's Fury",
    icon: 'inv_misc_stormlordsfavor',
  },
  STORMRIDERS_FURY_BUFF: {
    id: 449100,
    name: "Storm's Fury",
    icon: 'inv_misc_stormlordsfavor',
  },

  /* Template */
  // X_ENCHANT: {
  //     id: 0,
  //     name: '',
  //     icon: '',
  // },
  // X_BUFF: {
  //     id: 0,
  //     name: '',
  //     icon: '',
  // },
};

export default enchants;
